import { makeVar } from '@apollo/client'

import { JobsType } from '../mockData/jobs'
import { FullJobStatueAndDetails, Status } from '../types/BulkAccessManagement'
import { JobStatusForRateplan } from '../types/rateplan'

export const jobsListVar = makeVar<JobsType[]>(
  localStorage.jobs ? JSON.parse(localStorage.jobs) : []
)

export const addJob = (newJob: JobsType) => {
  const newJobsList = [...jobsListVar(), newJob]
  localStorage.setItem('jobs', JSON.stringify(newJobsList))
  jobsListVar(newJobsList)
}

export const updateJobStatus = (jobIndex: number, newStatus: Status) => {
  if (jobIndex < 0) {
    return
  }
  const newJobsList: JobsType[] = [
    ...jobsListVar().slice(0, jobIndex),
    {
      ...jobsListVar()[jobIndex],
      status: newStatus
    },
    ...jobsListVar().slice(jobIndex + 1)
  ]

  localStorage.setItem('jobs', JSON.stringify(newJobsList))
  jobsListVar(newJobsList)
}

export const updateJobStatusForAccessManagement = (
  jobIndex: number,
  newStatus: Status,
  email: string
) => {
  if (jobIndex < 0) {
    return
  }
  let temp: FullJobStatueAndDetails[] = jobsListVar()[jobIndex].subjobs || []
  const subJobIndex = temp.findIndex((v) => v.email === email)
  temp = [
    ...temp.slice(0, subJobIndex),
    {
      ...temp[subJobIndex],
      status: newStatus
    },
    ...temp.slice(subJobIndex + 1)
  ]

  const newJobsList: JobsType[] = [
    ...jobsListVar().slice(0, jobIndex),
    {
      ...jobsListVar()[jobIndex],
      subjobs: temp,
      status: temp
        .map((item) => item.status)
        .every((ele) => ele === 'FinishedSuccessfully')
        ? 'FinishedSuccessfully'
        : 'InProgress'
    },
    ...jobsListVar().slice(jobIndex + 1)
  ]

  localStorage.setItem('jobs', JSON.stringify(newJobsList))
  jobsListVar(newJobsList)
}

export const updateJobStatusForCreateRateplan = (
  jobIndex: number,
  newStatus: Status,
  code: string
) => {
  if (jobIndex < 0) {
    return
  }
  let temp: JobStatusForRateplan[] =
    jobsListVar()[jobIndex].subjobsForGenerateRatePlan || []
  const subJobIndex = temp.findIndex((v) => v.code === code)
  temp = [
    ...temp.slice(0, subJobIndex),
    {
      ...temp[subJobIndex],
      status: newStatus
    },
    ...temp.slice(subJobIndex + 1)
  ]

  const newJobsList: JobsType[] = [
    ...jobsListVar().slice(0, jobIndex),
    {
      ...jobsListVar()[jobIndex],
      subjobsForGenerateRatePlan: temp,
      status: temp
        .map((item) => item.status)
        .every((ele) => ele === 'FinishedSuccessfully')
        ? 'FinishedSuccessfully'
        : 'InProgress'
    },
    ...jobsListVar().slice(jobIndex + 1)
  ]

  localStorage.setItem('jobs', JSON.stringify(newJobsList))
  jobsListVar(newJobsList)
}
